import { render, staticRenderFns } from "./SidebarButtonGroup.vue?vue&type=template&id=3914eb7a&scoped=true&"
import script from "./SidebarButtonGroup.vue?vue&type=script&lang=js&"
export * from "./SidebarButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./SidebarButtonGroup.vue?vue&type=style&index=0&id=3914eb7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3914eb7a",
  null
  
)

export default component.exports